var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModalBackdrop',{attrs:{"value":!!_vm.visibleAlert}},[(!!_vm.visibleAlert)?_c(_vm.component,_vm._g(_vm._b({tag:"component"},'component',_vm.props,false),_vm.events)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }